function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione04Popup01Ico03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.13 70.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 47.27,
    y1: 36.38,
    x2: 33.65,
    y2: 36.38,
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.39,7.76c0,3.76-3.05,6.81-6.81,6.81s-6.81-3.05-6.81-6.81S10.81.95,14.58.95s6.81,3.05,6.81,6.81ZM22.75,45.91c3.01,0,5.45-2.44,5.45-5.45v-17.4c0-2.06-1.33-3.89-3.28-4.55-.88-.3-3.53-1.22-3.53-1.22l-6.81,6.81-6.81-6.81s-2.65.92-3.53,1.22c-1.95.66-3.28,2.49-3.28,4.55v17.4c0,3.01,2.44,5.45,5.45,5.45M47.27,58.17h-4.09c-2.26,0-4.09-1.83-4.09-4.09V18.66c0-2.26,1.83-4.09,4.09-4.09h4.09",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.58,44.55v24.52M22.75,28.2v39.51c0,.75-.61,1.36-1.36,1.36H7.76c-.75,0-1.36-.61-1.36-1.36V28.2",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,41.83h-10.9v-10.9h10.9v10.9ZM58.17,20.03h-10.9v-10.9h10.9v10.9ZM58.17,63.62h-10.9v-10.9h10.9v10.9Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione04Popup01Ico03);
export default __webpack_public_path__ + "static/media/sezione-04-popup-01-ico-03.22b38938ee8cede1d89434bde396d6a6.svg";
export { ForwardRef as ReactComponent };